module.exports = __webpack_public_path__ + "a4ff4ffa525459587671c116eaad16e6.png";